import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Observable, of, Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {CidaasService} from '../../../../service/cidaas.service';
import {retryWithDelay} from '../../../../service/service.model';
import {ErrorPageParams, errorPageParamsToQueryParams, errorPageParamsToUrl, mapParamsToErrorPage} from './handle-error.model';

@Component({
  selector: 'app-handle-error',
  templateUrl: './handle-error.component.html',
  styleUrls: ['./handle-error.component.scss']
})
export class HandleErrorComponent implements OnDestroy, OnInit {

  onDestroy$ = new Subject();
  pageLoading: boolean = false;
  constructor(
    private cidaasService: CidaasService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    ) { }

  ngOnInit(): void {
    this.pageLoading = true;

    this.activatedRoute.queryParams.pipe(
      takeUntil(this.onDestroy$),
      switchMap((params) => this.handleRedirectionFromParams(params))
   ).subscribe(
      (errorPageParams) => {
        this.pageLoading = false;
        if (errorPageParams.uri) {
          window.location.href =  errorPageParamsToUrl(errorPageParams).toString();
        } else {
          this.defaultErrorRedirection(errorPageParams);
        }
      },
      (_) => { this.defaultErrorRedirection(); }
    );
  }

  handleRedirectionFromParams(params: Params): Observable<ErrorPageParams> {

    if (!params.requestId) {
      return of(mapParamsToErrorPage(params));
    }

    return this.cidaasService._getClientInfoAsObs({ requestId: params.requestId })
      .pipe(
        retryWithDelay(),
        map(clientInfo => {
          return mapParamsToErrorPage(params, clientInfo.error_page_uri);
        }),
        catchError(_ => of(mapParamsToErrorPage(params))),
      );
  }

  defaultErrorRedirection(errorPageParams?: ErrorPageParams): void {
    this.router.navigate(['/error'],
    {
     queryParams: errorPageParams && errorPageParamsToQueryParams(errorPageParams)
   });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
